import type { ReactNode } from "react";
import { cn } from "@/shared/lib/cn";

interface Props {
  suggestions: ReadonlyArray<string>;
  selected: ReadonlyArray<string>;
  max: number;
  onAppend: (tag: string) => void;
}

/// Curated single-tap chips that append to a freeform tags field. Pairs
/// with `<ChipsField name="valueTags">`. Visual reference: severity radio
/// chips, but always single-select-append (no clearable).
export function SuggestedValueChips({ suggestions, selected, max, onAppend }: Props): ReactNode {
  return (
    <div className="flex flex-col gap-2">
      <span className="text-sm font-medium">Suggested values</span>
      <div className="flex flex-wrap gap-1.5">
        {suggestions.map((tag) => {
          const active = selected.includes(tag);
          const disabled = active || selected.length >= max;
          return (
            <button
              key={tag}
              type="button"
              onClick={() => onAppend(tag)}
              disabled={disabled}
              className={cn(
                "inline-flex items-center rounded-full px-2 py-0.5 text-xs transition-colors",
                "focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring",
                active
                  ? "bg-pulse-soft text-text-brand-strong"
                  : "border border-border bg-surface-subtle text-text-secondary hover:bg-surface-muted disabled:cursor-not-allowed disabled:opacity-50",
              )}
            >
              {active ? "✓ " : "+ "}
              {tag}
            </button>
          );
        })}
      </div>
      <p className="text-2xs text-text-tertiary">Tap to add. Or type your own below.</p>
    </div>
  );
}
